const TOKEN_VALIDATED = 'TOKEN_VALIDATED';
const USER_FETCHED = 'USER_FETCHED';
const USER_LOGOUT = 'USER_LOGOUT';

export {TOKEN_VALIDATED, USER_FETCHED, USER_LOGOUT}
